export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    // handle error, e.g. report to a service
    console.log('errorHandler error:', error)
    console.log('errorHandler instance:', instance)
    console.log('errorHandler info:', info)
  }

  // Also possible
  nuxtApp.hook('vue:error', (error, instance, info) => {
    // handle error, e.g. report to a service
    console.log('vue:error error:', error)
    console.log('vue:error instance:', instance)
    console.log('vue:error info:', info)
  })
})